module.exports = __webpack_public_path__ + "static/media/redeem_active.ade87e14.png";